const getDefaultState = () => {
  return {
    gates: [],
  }
}

export default getDefaultState
